module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/generator-b89fa4ee0692643cc4de4d8a46c6d5dd.svg";